import config from '@iotv/config'
import { AdjacentType, LogicalOperatorType } from '@iotv/iotv-v3-types'
import { QueryCommandInput } from '@aws-sdk/lib-dynamodb'
import { NativeAttributeValue } from '@aws-sdk/util-dynamodb'
import { DEBUG_OVERRIDE, NOT_LAMBDA } from '../lambda'
import { getZombieInstanceFromPrimaryKey } from '../TypeHelpers'
import { addFilterPartsToParams, getKeyNameSub, getKeyValueSub } from './queryPartBuilderFns'
import { GetQueryBodyRequest, QueryInputizerProps } from './types'

const debug = DEBUG_OVERRIDE || (NOT_LAMBDA && false)
const dyn = config.aws.dynamoDB

// TODO getQueryBody needs to deal with where filter expresssion does not work when converted to key expression: err: Error: Invalid operator used in KeyConditionExpression: <>
// {
//     key: dyn.sKey, predicate: ComparisonType.NOT_EQUALS, value: contextObject.sk
// }

/**
 * @function getQueryBody produces a DocumentClient.QueryInput from iotv system types. To use to get items by type set the contextObject of params in the form { sk: 'TargetType'}
 * @param param0
 * @returns
 */

export const getQueryBody = ({
  contextObject,
  adjacencyType,
  ExclusiveStartKey,
  limit = 500,
  groupSetOperation = LogicalOperatorType.AND,
  filterGroups,
}: GetQueryBodyRequest): QueryCommandInput => {
  const keyLookUp: { [k in AdjacentType]: { hashKey: string; sortKey: string; hashKeyValue: NativeAttributeValue; IndexName: string | undefined } } = {
    [AdjacentType.PARENT]: {
      hashKey: dyn.sKey,
      sortKey: dyn.pKey,
      hashKeyValue: contextObject?.sk ?? 'never',
      IndexName: dyn.gsiName,
    },
    [AdjacentType.CHILD]: {
      hashKey: dyn.pKey,
      sortKey: dyn.sKey,
      hashKeyValue: contextObject?.sk,
      IndexName: undefined,
    },
    [AdjacentType.SUBJECT]: {
      hashKey: dyn.typesiPrimaryKey,
      sortKey: dyn.typesiSortKey,
      hashKeyValue: contextObject ? getZombieInstanceFromPrimaryKey(contextObject.sk)?.type : '',
      IndexName: dyn.typesiName,
    },
  }

  if (!contextObject) {
    adjacencyType = AdjacentType.SUBJECT
  }

  const { hashKey, hashKeyValue, IndexName } = keyLookUp[adjacencyType as AdjacentType]

  const hashKeyNameSub: string = getKeyNameSub(hashKey)
  const hashKeyValueSub: string = getKeyValueSub(hashKey)

  const params: QueryInputizerProps = {
    TableName: dyn.tableName,
    IndexName,
    ExclusiveStartKey,
    ExpressionAttributeValues: {
      [hashKeyValueSub]: hashKeyValue,
    },
    Limit: limit,
    ExpressionAttributeNames: {
      [hashKeyNameSub]: hashKey,
    },
    KeyConditionExpression: `${hashKeyNameSub} = ${hashKeyValueSub}`,
    FilterExpression: undefined,
  }

  /** 2024 03 - filter to nodes only if subject  */
  if (adjacencyType === AdjacentType.SUBJECT) {
    const pKeySub = getKeyNameSub(dyn.pKey)
    const sKeySub = getKeyNameSub(dyn.sKey)
    params.ExpressionAttributeNames[pKeySub] = dyn.pKey
    params.ExpressionAttributeNames[sKeySub] = dyn.sKey
    params.FilterExpression = `${pKeySub} = ${sKeySub}`
  }

  if (filterGroups) {
    addFilterPartsToParams({ params, groupSetOperation, filterGroups, adjacencyType, keyLookUp })
  }
  return params
}
